export default class CitySerializer {
  static serialize(data) {
    const payload = {
      ...data,
      name: data.name,
      state_id: data.state,
      zip_code: data.zipCode
    };

    const customProperties = [
      "state",
      "zipCode"
    ];

    customProperties.forEach(prop => delete payload[prop]);
    return payload;
  }

  static deSerialize(data) {
    return {
      ...data,
      name: data.name,
      state: data.state_id,
      zipCode: data.zip_code
    };
  }
}